// Re-export everything from auth module
export * from '../auth';
export { firebaseApp, firebaseAuth, firestore, firebaseDb, firebaseStorage } from '../auth/firebase';
export { useCurrentUser } from '../auth/useCurrentUser';
export { UserGuard, UserGuardContext, useUserGuardContext } from '../auth/UserGuard';

// Import for local use
import { firebaseAuth as fbAuth } from '../auth/firebase';

// Define mode and other app constants
export type Mode = 'prod' | 'dev';
export const mode: Mode = import.meta.env.MODE === 'production' ? 'prod' : 'dev';

// App configuration
export const APP_BASE_PATH = '/';

// API URL — always resolve relative to the current origin under `/api`.
// We intentionally don't honour `VITE_API_URL` because deployed builds
// were sometimes baked with an env var that pointed at the host root
// (no `/api` suffix), which caused uploads / non-GET requests to fall
// through to the SPA's static-handler fallback and return 405
// Method Not Allowed. This matches how `brain.ts` constructs its base
// URL (`window.location.origin + '/api'`).
export const API_URL = '/api';

// Auth instance for convenience (alias)
export { getAuth } from 'firebase/auth';
export const auth = {
  ...fbAuth,
  // Add the getAuthHeaderValue method that brain expects
  getAuthHeaderValue: async () => {
    const currentUser = fbAuth.currentUser;
    if (!currentUser) {
      return '';
    }
    try {
      const token = await currentUser.getIdToken();
      return `Bearer ${token}`;
    } catch (error) {
      console.error('Error getting auth token:', error);
      return '';
    }
  },
  // Return just the raw ID token (used by `useDocumentLogsQuery` etc.).
  // Consumers typically prefix "Bearer " themselves when building headers.
  getAuthToken: async (): Promise<string | null> => {
    const currentUser = fbAuth.currentUser;
    if (!currentUser) return null;
    try {
      return await currentUser.getIdToken();
    } catch (error) {
      console.error('Error getting auth token:', error);
      return null;
    }
  }
};
